export default "__VITE_ASSET__4v3T2j2W__"